import { z } from "zod";
import { BasketSchema } from "./Basket";
import { ProductSchema } from "./Product";

export const BasketPositionsFieldsSchema = z.object({
  id: z.number().int(),
  priceNetto: z.number(),
  quantity: z.number(),
  attributes: z.any(),
  priceBrutto: z.number(),
  priceVat: z.number(),
  modificationDate: z.string(),
  changeQuantity: z.any(),
  customName: z.string(),
  margin: z.any(),
  basePriceNetto: z.number(),
  basePriceBrutto: z.number(),
  valueNetto: z.number(),
  valueBrutto: z.number(),
  product: ProductSchema,
  vat: z.object({
    vatId: z.number(),
    importId: z.number(),
    importCode: z.string(),
    importTyp: z.string(),
    vatName: z.string(),
    vatValue: z.number(),
    vatDescription: z.string(),
    id: z.number(),
  }),
  measureUnit: z.object({
    measureUnitId: z.number(),
    name: z.string(),
    shortName: z.string(),
    importId: z.number(),
    importCode: z.string(),
    importTyp: z.string(),
    id: z.number(),
  }),
  basket: BasketSchema,
  productCompletes: z.array(z.unknown()),
  productFreetype: z.any(),
  document: z.any(),
});

export const PartialBasketPositionsFieldsSchema =
  BasketPositionsFieldsSchema.deepPartial();

export const BasketPositionsExtraFieldsSchema = z.object({
  availableTemplates: z.array(z.number()),
});
export const PartialBasketPositionExtraFieldsSchema =
  BasketPositionsExtraFieldsSchema.deepPartial();

export const BasketPositionSchema = z.intersection(
  BasketPositionsFieldsSchema,
  BasketPositionsExtraFieldsSchema
);

export type BasketPositionFields = z.infer<typeof BasketPositionsFieldsSchema>;
export type PartialBasketPositionFields = z.infer<
  typeof PartialBasketPositionsFieldsSchema
>;
export type BasketPositionExtraFields = z.infer<
  typeof BasketPositionsExtraFieldsSchema
>;
export type PartialBasketPositionExtraFields = z.infer<
  typeof PartialBasketPositionExtraFieldsSchema
>;
export type BasketPosition = z.infer<typeof BasketPositionSchema>;
